import {modify} from 'mythil/object';

import {MODEL_ACTIONS} from "~/actions/model_actions"
import {getModelName, getFieldData, getModelTree, getItemId} from "~/stateGetter";
import identify from "~/identify";
import clearMessages from "~/reducers/helpers/clearMessages";
import loadModelPath from "~/reducers/helpers/loadModelPath";
import lexModelPathName from '~/navigation/helpers/lexModelPathName';

export const reduceRelationshipField = (state, action) => {
    switch(action.type) {
        case MODEL_ACTIONS.SET_ACTIVE_RELATIONSHIP_FIELD: {
            state = modify(state, `ui.loadedModels.${action.parentModelId}`, (model) => {
                const activeRelationshipField = action.fieldName
                        ? { ...getFieldData(state, model.modelId, identify.EDITFIELD, action.fieldName), activated_at: Date.now() }
                        : null;

                return modify(model, 'activeRelationshipField', activeRelationshipField);
            });

            state = modify(state, `ui.loadedModels.${action.modelId}`, (model) => clearMessages(model));
            
            state = modify(state, "ui", (ui) => {
                if (!action.fieldName) {
                    return loadModelPath(
                        ui,
                        lexModelPathName(state.router.pathname),
                        false,
                        false,
                        state
                    )
                }

                const path = lexModelPathName(`/${getModelName(state, action.modelId)}/${action.itemId || identify.NEW_ITEM + ""}`);
                let currentModelId = action.modelId;

                
                while(true) {
                    const parentModel = getModelTree(state).getParentModel(currentModelId);
                    if (!parentModel) break;

                    currentModelId = parentModel.modelId;
                    let itemId = getItemId(state, currentModelId);
                    itemId = itemId ? "/" + itemId : "";
                    path.unshift(...lexModelPathName(`/${getModelName(state, currentModelId)}${itemId}`));
                }



                return loadModelPath(
                    ui,
                    path,
                    false,
                    false,
                    state
                )
            });
        }
    }

    return state;
}